// TemplateListModal's header row and TemplateRow's body row must render the same column widths
// (round 3 of a fix once drifted 92px vs 70px); both read them from here.
export const TEMPLATE_COLUMNS = {
  // Manage Templates (letter 99, 2.3 / 2.2.2): dates right-aligned ending 16 before the icons, icons
  // 14 + 8 + 14 + 8 + 10 = 54 (30.09 export, #templates-pop-up).
  manageDate: 'w-[100px]',
  manageIconGap: 'ml-[16px]',
  manageIcons: 'w-[54px]',
}
